module.exports = __webpack_public_path__ + "img/nw.2ea5ced2.png";